import ListCashSales from "../../../../components/@documents/cash_sales/ListCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CashSalesPage() {

    return (
        <ListCashSales 
            routeType={routeTypes.admin}
        />
    )
}